
import { defineComponent, computed, ref, watch, onMounted, onBeforeUnmount, onUnmounted } from "vue";
import { useStore } from "vuex";
import LoginPage from "./features/auth/LoginPage.vue";
import ErrorPage from "./components/Error.vue";
import OKDialog from "./components/OKDialog.vue";
import ApplicationService from "./services/applicationService";
import routerService from "./services/router.service";
import { DEFAULT_APP_PROPERTIES } from "./shared/config";

export default defineComponent({
  name: "HomePage",
  props: DEFAULT_APP_PROPERTIES,
  components: { LoginPage, ErrorPage, OKDialog },
  setup(props, { emit }) {
    // development mode can be specified by user configuration. It will default to false.
    const developmentMode = props.developmentMode ? props.developmentMode : false;
    console.log(`Running in ${developmentMode ? "development" : "embedded"} mode`);
    if (!developmentMode) console.log(`App Properties: ${JSON.stringify(props, null, 4)}`);

    ApplicationService.initialiseApplication(props.server);

    const store = useStore();
    let appSessionKeyInStore = ref("");

    // compute the AppSessionKey from the auth store
    // get the two contact book sizes from the contactBook store
    appSessionKeyInStore = computed(() => store.getters["auth/getAppSessionKey"]);
    const userContactBookSize = computed(() => store.getters["contactBook/getUserContactBookSize"]);
    const groupContactBookSize = computed(() => store.getters["contactBook/getGroupContactBookSize"]);
    // preventRouteChange flag comes from the store and allows the Org app to prevent routing if the user is
    // editing inside of a vue component
    const preventRouteChange = computed(() => store.getters["application/getPreventRouteChange"]);

    onBeforeUnmount(async () => {
      console.log("Vue App - onBeforeUnmount");
    });

    onUnmounted(async () => {
      console.log("Vue App - onUnmounted");
    });

    if (developmentMode) {
      // watch for the appSessionKey and once we have one,
      // dispatch the loadChunkCount and loadStatic data actions
      watch(appSessionKeyInStore, (currentValue, oldValue) => {
        if (currentValue) {
          store.dispatch("contactBook/loadChunkCount");
          store.dispatch("staticData/loadStaticData");
        }
      });

      // watch for the userContactBookSize and once we have a value,
      // dispatch the loadContacts action
      watch(userContactBookSize, (currentValue, oldValue) => {
        if (currentValue) {
          store.dispatch("contactBook/loadContacts");
        }
      });

      // get the app session key and uuid from storage
      const appSessionKey = localStorage.getItem("appSessionKey");
      const uuid = localStorage.getItem("uuid");
      store.dispatch("auth/setCredentials", props.credentials);
    } else {
      // in production mode we just populate the store with the properties
      // passed to the app
      store.dispatch("auth/setCredentials", props.credentials);
    }

    const router = routerService.getRouter();

    const menuItems = ref([
      {
        label: "Fulfilment",
        items: [
          {
            label: "Fulfil Items",
            icon: "pi pi-user",
            command: () => {
              router.push("fulfilment");
            },
          },
        ],
      },
      {
        label: "Cashless",
        items: [
          {
            label: "Account Linking",
            icon: "pi pi-link",
            command: () => {
              router.push("unlinked");
            },
          },
          {
            label: "Reconcilation",
            icon: "pi pi-check-circle",
            command: () => {
              router.push("reconciliation");
            },
          },
        ],
      },
      {
        label: "",
        items: [
          {
            label: "Contact Book",
            icon: "pi pi-users",
            command: () => {
              router.push("demo");
            },
          },
          {
            label: "Logout",
            icon: "pi pi-arrow-left",
            command: () => {
              store.dispatch("auth/logout");
            },
          },
        ],
      },
    ]);

    return {
      developmentMode,
      appSessionKeyInStore,
      menuItems,
      preventRouteChange,
    };
  },
});
